import * as runtime from '@/api/runtime'
import {
  BatchSchoolStatisticsReadNewStudentCsvFileRequest,
  BatchSchoolStatisticsReadNewStudentCsvFileRequestToJSON,
  BatchSchoolStatisticsRegisterNewStudentRequest,
  NewStudent,
  NewStudentFromJSON,
  BatchSchoolStatisticsRegisterNewStudentRequestToJSON
} from '@/api'
import { HTTPQuery } from '@/api/runtime'

export class BatchSchoolStatisticsNewStudentRegistrationApi extends runtime.BaseAPI {
  /**
   * csvファイルにより新入生を読み取る
   * 新入生読み取り
   */
  async readNewStudentCsvFile(
    request: BatchSchoolStatisticsReadNewStudentCsvFileRequest
  ): Promise<NewStudent[]> {
    const queryParameters: runtime.HTTPQuery = Object.fromEntries(
      Object.entries(
        BatchSchoolStatisticsReadNewStudentCsvFileRequestToJSON(request)
      ).filter(value => value[1] !== undefined)
    ) as HTTPQuery
    const response = await this.requestGet(
      '/batch/school-statistics/new-student-registration/read-csv',
      queryParameters
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      jsonValue.map(NewStudentFromJSON)
    ).value()
  }

  /**
   * 新入生を登録する
   * 新入生登録
   */
  async registerNewStudent(
    request: BatchSchoolStatisticsRegisterNewStudentRequest
  ): Promise<runtime.VoidApiResponse> {
    const bodyParameters: runtime.HTTPBody = BatchSchoolStatisticsRegisterNewStudentRequestToJSON(
      request
    )
    const response = await this.requestPost(
      '/batch/school-statistics/new-student-registration',
      bodyParameters
    )

    return new runtime.VoidApiResponse(response)
  }
}
